import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { AutomationDirective } from '@frontend/sports/automation/core-feature';
import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { PlainLinkComponent } from '@frontend/vanilla/core';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    selector: 'ms-item',
    templateUrl: './item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AutomationDirective, NgTemplateOutlet, PlainLinkComponent, SpeculativeLinkDirective, IconCustomComponent],
    host: {
        class: 'list-item',
    },
})
export class ItemComponent {
    private trackerService = inject(TrackingService);

    title = input<string | undefined>();
    count = input<number | undefined>();
    icon = input<string | undefined>();
    href = input<string | undefined>();
    regionIds = input<number[]>();
    tracking = input<string | undefined>('M2_quicklinks');
    arrow = input(true);
    attribute = input<string | undefined>();
    readonly itemClicked = output();
    readonly isEpcotEnabled = inject(EpcotConfig).isEnabled;

    get isCountryFlag(): boolean {
        return !!this.icon()?.includes('-flag');
    }

    clicked(): void {
        if (this.tracking()) {
            this.trackerService.update({ [trackingConstants.PAGE_REFERRING_ACTION]: this.tracking() });

            if (this.href()?.indexOf('http') === 0) {
                this.trackerService.triggerEventWithCleaning();
            }
        }
        this.itemClicked.emit();
    }
}
